import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import GoogleCallback from './pages/GoogleCallback';
import Dashboard from './pages/Dashboard';
import UsersPage from './pages/UsersPage';
import ReferencePage from './pages/ReferencePage';
import ReportForm from './pages/ReportForm';
import ReportsList from './pages/ReportsList';
import AdminPanel from './pages/AdminPanel';
import Profile from './pages/Profile';
import Layout from './components/Layout';

const App: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if PWA/mobile and redirect to report form
  const isPWA = window.matchMedia('(display-mode: standalone)').matches;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  const shouldRedirectToReport = isPWA || isMobile;

  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to={shouldRedirectToReport ? '/report/new' : '/'} />} />
      <Route path="/auth/callback" element={<GoogleCallback />} />
      <Route
        path="/"
        element={user ? <Layout /> : <Navigate to="/login" />}
      >
        <Route index element={shouldRedirectToReport && user ? <Navigate to="/report/new" replace /> : <Dashboard />} />
        <Route path="report/new" element={<ReportForm />} />
        <Route path="reports" element={<ReportsList />} />
        <Route path="admin/users" element={user?.isAdmin ? <UsersPage /> : <Navigate to="/" />} />
        <Route path="reference/*" element={user?.isAdmin ? <ReferencePage /> : <Navigate to="/" />} />
        <Route path="admin/*" element={user?.isAdmin ? <AdminPanel /> : <Navigate to="/" />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  );
};

export default App;

